import {bus} from "@/plugins/bus";

export class CustomApexChart {
  chart = null;
  intervalId = null;

  constructor(selector: string, options: any) {
    this.insertApexChart();
    this.initChart(selector, options);
  }

  insertApexChart() {
    let scriptLoaded = Boolean(document.getElementById('apexchart-script'));
    if (!scriptLoaded) {
      let externalScript = document.createElement('script');
      externalScript.setAttribute('src', 'https://cdn.jsdelivr.net/npm/apexcharts');
      externalScript.setAttribute('id', `apexchart-script`);
      document.head.appendChild(externalScript);
    }
  }

  initChart(selector: string, options: any) {
    this.intervalId = setInterval(() => {
      try {
        // @ts-ignore
        this.chart = new ApexCharts(document.querySelector(selector), options);
      }
      catch (e) {}

      if (this.chart) {
        clearInterval(this.intervalId);
        try {
          this.chart.render();
          setTimeout(() => bus.$emit('apexChart:ready'), 0);
        }
        catch (e) {}
      }
    }, 100);
  }

  destroyChart() {
    if (this.chart) this.chart.destroy();
  }
}
